import { Link, NavLink } from "react-router-dom";
import { UserRound } from "lucide-react";
import { BrandLogo } from "@/components/ax/BrandLogo";
import styles from "@/components/sheet/LembarVisual.module.css";
import { Mark, Wordmark } from "@/components/ax/Mark";
import { NAV } from "@/components/shell/nav";
import { useI18n } from "@/i18n";

export const MobileHeader = ({ stitch = false }) => {
  const { t } = useI18n();
  return (
  <header
    data-testid="mobile-header"
    className="sticky top-0 z-20 flex h-14 items-center gap-3 border-b border-ax-border bg-ax-bg px-4 md:hidden"
  >
    {stitch ? <><BrandLogo /><Link to="/akun" aria-label={t("nav.account")} className={styles.accountLink}><UserRound size={18} strokeWidth={1.5} aria-hidden="true" /></Link></> : <><Mark size={24} className="text-ax-brand" /><Wordmark className="text-ax-brand" /></>}
  </header>
  );
};

export const TabBar = () => {
  const { t } = useI18n();
  return (
    <nav
      aria-label={t("nav.main")}
      data-testid="mobile-tabbar"
      className="fixed inset-x-0 bottom-0 z-30 border-t border-ax-border bg-ax-surface pb-[var(--safe-bottom)] md:hidden"
    >
      <ul className="m-0 grid h-14 list-none grid-cols-5 p-0">
        {NAV.map(({ key, to, icon: Icon, labelKey, end }) => (
          <li key={key} className="min-w-0">
            <NavLink
              to={to}
              end={end}
              data-testid={`tab-${key}`}
              className={({ isActive }) =>
                `relative flex h-14 flex-col items-center justify-center gap-1 px-1 text-[11px] font-medium leading-3 ${
                  isActive ? "text-ax-link" : "text-ax-muted"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <span aria-hidden="true" className="absolute inset-x-3 top-0 h-[2px] bg-ax-accent" />
                  )}
                  <Icon size={20} strokeWidth={1.5} aria-hidden="true" />
                  <span className="max-w-full truncate leading-[14px]">{t(labelKey)}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};
